module.exports = __webpack_public_path__ + "img/google.d1d14f62.png";